var _path, _path2, _path3, _path4;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUserSearch = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.5C17.66 25.5 12.5 20.34 12.5 14C12.5 7.66 17.66 2.5 24 2.5C30.34 2.5 35.5 7.66 35.5 14C35.5 20.34 30.34 25.5 24 25.5ZM24 5.5C19.32 5.5 15.5 9.32 15.5 14C15.5 18.68 19.32 22.5 24 22.5C28.68 22.5 32.5 18.68 32.5 14C32.5 9.32 28.68 5.5 24 5.5Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82031 45.5C6.00031 45.5 5.32031 44.82 5.32031 44C5.32031 35.46 13.7004 28.5 24.0004 28.5C24.8204 28.5 25.5004 29.18 25.5004 30C25.5004 30.82 24.8204 31.5 24.0004 31.5C15.3604 31.5 8.32031 37.1 8.32031 44C8.32031 44.82 7.64031 45.5 6.82031 45.5Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4 44.3C32.04 44.3 28.5 40.76 28.5 36.4C28.5 32.04 32.04 28.5 36.4 28.5C40.76 28.5 44.3 32.04 44.3 36.4C44.3 40.76 40.76 44.3 36.4 44.3ZM36.4 31.5C33.7 31.5 31.5 33.7 31.5 36.4C31.5 39.1 33.7 41.3 36.4 41.3C39.1 41.3 41.3 39.1 41.3 36.4C41.3 33.7 39.1 31.5 36.4 31.5Z",
    fill: "#455CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9999 45.4999C43.6199 45.4999 43.2399 45.36 42.9399 45.06L40.9399 43.06C40.3599 42.48 40.3599 41.5199 40.9399 40.9399C41.5199 40.3599 42.48 40.3599 43.06 40.9399L45.06 42.9399C45.64 43.5199 45.64 44.48 45.06 45.06C44.76 45.36 44.3799 45.4999 43.9999 45.4999Z",
    fill: "#455CC7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user-search.704d5d1d.svg";
export { ForwardRef as ReactComponent };